// extracted by mini-css-extract-plugin
export var aircallIframe = "_fv-3";
export var fabContainer = "_fv-5";
export var fabRinging = "_fv-6";
export var loadingOverlay = "_fv-4";
export var pulse = "_fv-7";
export var widgetContent = "_fv-2";
export var widgetPanel = "_fv-0";
export var widgetPanelExpanded = "_fv-1";